import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar, Button, Card, CardActionArea, CardContent, Typography, } from "@mui/material";
import { useState } from "react";
import { Link } from "react-router-dom";
export const LeagueCard = ({ league }) => {
    const MAX_LENGTH = 120;
    const [expanded, setExpanded] = useState(false);
    const description = league.description || "";
    const isLong = description.length > MAX_LENGTH;
    const shownDescription = !isLong || expanded
        ? description
        : description.slice(0, MAX_LENGTH).trimEnd() + "…";
    return (_jsx(Card, { children: _jsx(CardActionArea, { component: Link, to: `/leagues/${league.id}/`, children: _jsxs(CardContent, { sx: { display: "flex", alignItems: "center", gap: 2 }, children: [_jsx(Avatar, { alt: league.name, src: league.logo || undefined, sx: { width: 56, height: 56 }, children: league.name.match(/\b(\w)/g)?.join("") }), _jsxs("div", { children: [_jsx(Typography, { variant: "h6", children: league.name }), description && (_jsxs(Typography, { variant: "body2", color: "text.secondary", component: "div", children: [shownDescription, isLong && (_jsx(Button, { size: "small", color: "primary", onClick: (e) => {
                                            e.preventDefault(); // prevent link navigation when toggling
                                            setExpanded((prev) => !prev);
                                        }, sx: {
                                            ml: 1,
                                            textTransform: "none",
                                            padding: 0,
                                            minWidth: "auto",
                                        }, children: expanded ? "Show less" : "Read more" }))] }))] })] }) }) }));
};
